const ru = {
  nav: {
    features: "Возможности",
    pricing: "Цены",
    getStarted: "Начать",
    signIn: "Войти",
    profile: "Профиль",
    atsCheck: "Проверить резюме",
    atsCheckBadge: "Free",
    requestDemo: "Заказать демо",
  },

  hero: {
    badge: "ИИ-подготовка к интервью",
    titleLine1: "Найдите свои слабые места",
    titleLine2: "до реального интервью",
    subtitle: "Загрузите резюме — получите мгновенный анализ сильных сторон и пробелов. Затем пройдите адаптивное голосовое интервью под вашу вакансию с детальной оценкой готовности.",
    subtitleSignedIn: "Вставьте описание вакансии — мы подберём вопросы под ваше резюме и запустим адаптивное голосовое интервью с оценкой готовности.",
    placeholder: "Вставьте описание вакансии сюда...",
    analyzing: "Готовим интервью...",
    analyzeBtn: "Запустить интервью",
    analyzingHint: "Для длинных описаний может занять до 20 секунд.",
    tryAgain: "Попробовать снова",
    trustPrivate: "100% приватно",
    trustFaang: "Калибровка под FAANG",
    trustVoice: "Голосовое интервью",
  },

  // JD section for signed-in users (above JD textarea)
  jdSection: {
    title: "Опишите вакансию — запустим интервью",
    subtitle: "Вставьте описание вакансии. Мы извлечём ключевые компетенции и сразу запустим голосовое интервью под ваш опыт.",
  },

  preview: {
    title: "3 бесплатных сложных вопроса",
    competenciesFound: "компетенций найдено",
    hard: "Сложный",
    medium: "Средний",
    behavioral: "Поведенческий",
    startBtn: "🎙️ Начать полное голосовое интервью",
    startDesc: "Адаптивный ИИ-интервьюер, который находит границы ваших знаний",
    questionPrefix: "Углублённый вопрос по",
  },

  features: {
    voiceTitle: "Голосовое интервью в реальном времени",
    voiceDesc: "Говорите естественно. ИИ слушает, понимает и копает глубже — как настоящий старший интервьюер.",
    boundaryTitle: "Определение границ знаний",
    boundaryDesc: "ИИ не останавливается на поверхностных ответах. Он копает, пока не найдёт, где именно заканчиваются ваши знания.",
    analyticsTitle: "Глубокая аналитика готовности",
    analyticsDesc: "Радарные диаграммы, анализ пробелов, модельные ответы и оценка готовности для LinkedIn.",
  },

  pricing: {
    title: "Простые и прозрачные цены",
    subtitle: "Анализ резюме и вакансии — бесплатно. Полные интервью стоят дешевле, чем чашка кофе.",
    freeTitle: "Бесплатно",
    freeFeature1: "Анализ резюме и вакансии",
    freeFeature2: "3 сильных вопроса",
    freeFeature3: "Превью голосового интервью",
    freeFeature4: "Отчёт о готовности",
    currentPlan: "Текущий план",
    paidTitle: "Полный доступ",
    paidPrice: "$5",
    paidSub: "3 полноценных интервью",
    paidFeature1: "Безлимитный анализ вакансий",
    paidFeature2: "3 полных голосовых интервью",
    paidFeature3: "Детальные отчёты о готовности",
    paidFeature4: "Оценка для LinkedIn",
    paidBtn: "Получить полный доступ",
    mostPopular: "ПОПУЛЯРНЫЙ",
  },

  social: {
    trustedBy: "Инженеры готовятся к интервью в 100+ компаниях, включая",
  },

  footer: {
    copyright: "© 2026 HireFit. Все права защищены.",
    privacy: "Конфиденциальность",
    terms: "Условия",
    contact: "Контакты",
    forBusinesses: "Для бизнеса",
  },

  forCompanies: {
    title: "Нанимайте умнее — с голосовыми AI-интервью",
    subtitle:
      "Создайте вакансию, поделитесь ссылкой — и наш AI проведёт настоящее голосовое интервью с каждым кандидатом. На выходе — структурированный отчёт: оценки по компетенциям, полный транскрипт и резюме на скачивание. Без часового Zoom-созвона.",
    step1Title: "Создайте вакансию",
    step1Desc:
      "Вставьте описание позиции, выберите длительность интервью и уровень кандидата. Мы автоматически разберём компетенции.",
    step2Title: "Поделитесь ссылкой",
    step2Desc:
      "Каждая вакансия получает публичный URL. Кандидат загружает резюме, оставляет контакты и сразу попадает в живое AI-интервью — без регистрации.",
    step3Title: "Разбирайте отчёты в CRM",
    step3Desc:
      "Каждое завершённое интервью — карточка с оценками, вердиктом, транскриптом и PDF-резюме. Двигайте кандидатов по статусам одним кликом — не прошедшим автоматически уходит вежливое письмо с фидбеком.",
    howItWorks: "Как это работает",
    ctaButton: "Перейти в CRM →",
    ctaNote: "Войдите или зарегистрируйтесь с рабочей почтой. Попробовать бесплатно.",
    back: "← Вернуться к подготовке к интервью",
  },

  b2bPricing: {
    title: "Тарифы, которые растут вместе с наймом",
    subtitle:
      "В каждый тариф входят голосовые AI-интервью, структурированные отчёты и CRM кандидатов. Начните бесплатно и переходите выше по мере роста.",
    perMonth: "/мес",
    free: "Бесплатно",
    custom: "Индивидуально",
    mostPopular: "Популярный",
    currentPlan: "Текущий тариф",
    subscribe: "Подключить",
    getStarted: "Начать",
    contactSales: "Связаться с нами",
    yourPlan: "Ваш тариф",
    interviewsThisMonth: "Интервью в этом месяце",
    activeVacancies: "Активные вакансии",
    unlimited: "Безлимит",
    renews: "Продление",
    upgradeSuccess: "Готово — тариф активирован.",
    upgradeCanceled: "Оплата отменена. Изменений нет.",
    vacancyLimitReached: "Достигнут лимит вакансий вашего тарифа. Перейдите выше, чтобы добавить ещё.",
    plans: {
      starter: {
        name: "Starter",
        tagline: "Малые компании / тест",
        features: [
          "50 AI-интервью / мес",
          "1 активная вакансия",
          "Структурированные отчёты и транскрипты",
          "CRM кандидатов",
        ],
      },
      pro: {
        name: "Pro",
        tagline: "Средний бизнес / рекрутеры",
        features: [
          "100 AI-интервью / мес",
          "До 3 вакансий",
          "Всё из Starter",
          "Email-уведомления",
        ],
      },
      team: {
        name: "Team",
        tagline: "Рекрутинговые агентства",
        features: [
          "300 AI-интервью / мес",
          "До 10 вакансий",
          "Всё из Pro",
          "Приоритетная обработка",
        ],
      },
      enterprise: {
        name: "Enterprise",
        tagline: "Корпорации / крупные HR-отделы",
        features: [
          "Безлимит интервью и вакансий",
          "Кастомизация",
          "Приоритетная поддержка",
          "Персональный онбординг",
        ],
      },
    },
  },

  atsCheck: {
    title: "Бесплатная ATS-проверка резюме",
    subtitle:
      "Получите аудит резюме уровня HR-менеджера за 15 секунд. Добавьте вакансию — и мы покажем, каких ключевых слов вам не хватает и где пробелы в опыте.",
    signedOutCta: "Войдите, чтобы проверить резюме бесплатно",
    signedOutHint: "Нам нужен вход, чтобы считать ваши 5 бесплатных проверок в сутки.",
    resumeSectionTitle: "1. Ваше резюме",
    tabFile: "Загрузить файл",
    tabText: "Вставить текстом",
    fileCta: "Перетащите файл или нажмите для загрузки",
    fileHint: "PDF или DOCX, до 10 МБ",
    fileTooLarge: "Файл слишком большой (макс. 10 МБ).",
    fileWrongType: "Поддерживаются только PDF и DOCX.",
    textPlaceholder: "Вставьте полный текст резюме сюда...",
    jdSectionTitle: "2. Описание вакансии (опционально)",
    jdSectionHint:
      "Добавьте вакансию — и мы покажем, каких именно ключевых слов вам не хватает и где пробелы в опыте.",
    jdPlaceholder: "Вставьте описание вакансии, чтобы получить анализ соответствия и пробелов...",
    analyzeBtn: "Проанализировать резюме",
    analyzing: "Анализируем резюме...",
    quotaLabel: "Бесплатных проверок за сутки: {used}/{limit}",
    newCheckBtn: "Проверить ещё одно",
    resultTitle: "Анализ вашего резюме",
    scoreOutOf: "из 100",
    scoreExcellent: "Отлично — резюме готово к ATS",
    scoreGood: "Хорошо — нужны небольшие правки",
    scoreAverage: "Средне — нужны реальные улучшения",
    scoreBelow: "Ниже порога — скорее всего отсеется",
    issuesTitle: "Что исправить",
    noIssues: "Серьёзных проблем не обнаружено.",
    severityHigh: "Важно",
    severityMedium: "Средне",
    severityLow: "Мелочи",
    categoryFormatting: "Форматирование",
    categoryKeywords: "Ключевые слова",
    categoryStructure: "Структура",
    categoryClarity: "Ясность",
    categoryQuantification: "Метрики",
    categoryExperience: "Опыт",
    categoryContact: "Контакты",
    bulletsTitle: "Переписанные пункты",
    bulletsHint: "Более сильные формулировки с метриками и влиянием — можно вставить прямо в резюме.",
    bulletOriginal: "Ваш вариант",
    bulletImproved: "Улучшенный",
    bulletReason: "Почему лучше",
    copy: "Скопировать",
    copied: "Скопировано!",
    keywordMatchTitle: "Совпадение по ключевым словам",
    keywordScoreLabel: "Совпадение",
    keywordMatched: "Совпадает в вашем резюме",
    keywordMissing: "Отсутствует в резюме",
    keywordSuggestions: "Как улучшить",
    gapTitle: "Анализ пробелов",
    gapAligned: "Что совпадает",
    gapGaps: "Чего не хватает",
    gapRecommendations: "Рекомендации",
    missingResume: "Сначала загрузите или вставьте резюме.",
    rateLimited: "Лимит исчерпан. Можно 5 проверок в сутки — возвращайтесь завтра.",
    genericError: "Что-то пошло не так. Попробуйте ещё раз.",
    tryFullInterview: "Хотите попробовать полноценное интервью?",
    tryFullInterviewDesc:
      "Проверьте резюме на практике — адаптивное голосовое AI-интервью под вашу вакансию.",
    tryFullInterviewBtn: "Начать подготовку →",
  },

  trial: {
    daysLeft: "Осталось {n} дней",
    freeInterviews: "{n} бесплатных собеседований",
    expired: "Бесплатный период закончился",
    buyNow: "Купить собеседования",
  },

  quota: {
    signInToStart: "Войти, чтобы начать",
    noInterviewsRemaining: "Интервью закончились",
    buyInterviews: "Купить интервью",
    buyMore: "Купить ещё интервью — $5",
    checkingQuota: "Проверяем доступ...",
  },

  // legacy — used by hillel page
  paywall: {
    title: "Разблокировать полное интервью",
    desc: "Полное адаптивное голосовое интервью с глубокой аналитикой за $5 (3 интервью).",
    btn: "Получить полный доступ — $5",
    alreadyPaid: "Уже оплатили? Введите email:",
    emailPlaceholder: "ваш@email.com",
    check: "Проверить",
    tryFree: "Попробовать бесплатно (5 мин)",
    allUsed: "Все интервью использованы. Купите ещё.",
    notFound: "Покупка по этому email не найдена.",
    checkFailed: "Ошибка проверки. Попробуйте снова.",
    havePromo: "Есть промокод?",
    promoPlaceholder: "APEX-XXXXXX",
    redeemBtn: "Активировать",
    promoSuccess: "Промокод применён! Запускаем интервью...",
  },

  chat: {
    topicsToCover: "📋 Что обсудим",
    standardMode: "Стандартный режим",
    liveMode: "⚡ LIVE-режим (бета)",
    beginInterview: "Начать интервью",
    backBtn: "Назад",
    voiceInterview: "Голосовое интервью",
    liveInterview: "⚡ Live-интервью",
    endInterview: "Завершить интервью",
    you: "Вы",
    interviewer: "Интервьюер",
    aiSpeaking: "🔊 Отвечает ИИ...",
    aiListening: "🎤 Слушаю вас...",
    processing: "Распознаём ваш голос...",
    thinking: "Обдумываю ответ...",
    liveSpeak: "⚡ Live — говорите свободно",
    connecting: "Подключаемся...",
    disconnected: "Соединение потеряно",
    timeWarning: "осталось в бесплатной демо-версии. Оплатите полный доступ, чтобы продолжить.",
    timeEndingSoon: "до завершения интервью.",
    timeCutoff: "⏱️ Время бесплатной демо-версии вышло. Генерируем частичный отчёт...",
    audioError: "⚠️ Упс, что-то сломалось. Мы уже в курсе и чиним — попробуйте, пожалуйста, ещё раз через пару секунд.",
    retryBtn: "Повторить",
    dismissBtn: "Закрыть",
    startMessage: "Начать интервью.",
    doneSpeakingBtn: "Я закончил",
    micListening: "Слушаю",
    cameraPromptTitle: "Включите камеру",
    cameraPromptDesc: "Мы хотим записать ваше лицо во время интервью. Это помогает оценить невербальную коммуникацию и обеспечивает достоверность интервью. Камера не обязательна, но рекомендуется.",
    cameraActive: "Камера включена",
    cameraDenied: "Доступ к камере запрещён",
    cameraRequesting: "Запрашиваем доступ...",
    cameraEnable: "Включить камеру",
    cameraStartInterview: "Начать интервью с камерой",
    cameraSkip: "Пропустить — продолжить без камеры",
    gdprTitle: "Согласие на обработку данных",
    gdprDesc: "Во время этого интервью мы будем записывать и обрабатывать ваши голосовые ответы с помощью ИИ для оценки ваших технических компетенций. Вам также может быть предложено включить веб-камеру и демонстрацию экрана. Ваши данные обрабатываются в соответствии с GDPR и нашей Политикой конфиденциальности.",
    gdprPoint1: "Ваш голос будет записан и транскрибирован для ИИ-анализа",
    gdprPoint2: "Веб-камера и экран могут быть записаны для обеспечения достоверности интервью",
    gdprPoint3: "Ваши ответы будут использованы для создания отчёта о готовности",
    gdprPoint4: "Вы можете запросить удаление данных в любое время",
    gdprAccept: "Я согласен — продолжить",
    gdprDecline: "Отказаться",
    gdprPrivacyLink: "Политика конфиденциальности",
  },

  report: {
    title: "Отчёт о готовности",
    subtitle: "Оценка глубокого ИИ-интервью",
    shareBtn: "Поделиться в LinkedIn",
    shareCopied: "Скопировано! Вставьте в LinkedIn",
    overallReadiness: "Общая готовность",
    readyScreening: "Готов к скринингу",
    needsPrep: "Нужна подготовка",
    skillBreakdown: "Разбор навыков",
    you: "Вы",
    passingBar: "Проходной балл",
    focusArea: "Зона роста",
    criticalGaps: "Критические пробелы в знаниях",
    areasNeedImprovement: "областей требуют улучшения",
    aiAnalysis: "Анализ ИИ",
    modelAnswer: "Модельный ответ",
    majorMiss: "Серьёзный пробел",
    needsWork: "Нужна работа",
    redFlags: "Красные флаги",
    studyPlan: "Рекомендуемый план обучения",
    anotherRound: "Готовы к ещё одному раунду?",
    anotherRoundDesc: "Практика — путь к совершенству. Начните новое интервью, чтобы улучшить слабые места.",
    startNew: "Начать новое интервью",
    shareTitle: "Результаты скопированы!",
    shareDesc: "Результаты в буфере обмена. Нажмите",
    shareDescCtrl: "Ctrl+V",
    shareDescOr: "или",
    shareDescCmd: "Cmd+V",
    shareDescEnd: "чтобы вставить в пост LinkedIn.",
    openLinkedIn: "Открыть LinkedIn",
  },

  profile: {
    title: "Мой профиль",
    interviews: "История интервью",
    noInterviews: "Пока нет интервью",
    remaining: "интервью осталось",
    buyMore: "Купить +3 интервью ($5)",
    verdict: "Вердикт",
    viewReport: "Посмотреть отчёт",
    jobDescription: "Описание вакансии",
    competencies: "Оценки по компетенциям",
    redFlags: "Красные флаги",
    studyPlan: "План обучения",
    loading: "Загружаем профиль...",
    resume: "Моё резюме",
    resumeInfo: "Резюме будет сохранено и может быть предложено компаниям-партнёрам",
    uploadResume: "Загрузить резюме",
    uploadedAt: "Загружено",
    fileTooLarge: "Файл слишком большой (максимум 10 МБ)",
    invalidFileType: "Допускаются только файлы PDF и DOCX",
  },

  loading: {
    verifyingPayment: "Проверяем оплату...",
    generatingReport: "Генерируем отчёт о готовности...",
  },

  reportSkeleton: {
    title: "Собираем ваш отчёт",
    subtitle: "Ещё несколько секунд — анализируем интервью и подводим итоги.",
    hint: "Не закрывайте вкладку — отчёт появится здесь автоматически.",
    stages: [
      "Читаем ваш диалог...",
      "Оцениваем компетенции...",
      "Ищем слабые места...",
      "Готовим план обучения...",
      "Финальные штрихи...",
    ],
  },

  lang: {
    en: "EN",
    ru: "RU",
    cz: "CZ",
  },

  // Resume Input (resume-first landing)
  resumeInput: {
    tabUpload: "Загрузить PDF",
    tabPaste: "Вставить текст",
    uploadBtn: "Загрузить резюме",
    dragDropHint: "Перетащите PDF или DOCX сюда или нажмите для выбора",
    pastePlaceholder: "Вставьте текст резюме сюда...",
    analyzeBtn: "Анализировать резюме",
    analyzing: "Анализируем...",
    fileTooLarge: "Файл слишком большой. Максимальный размер — 10 МБ.",
    invalidFileType: "Неверный тип файла. Пожалуйста, загрузите PDF или DOCX.",
  },

  // Resume Feedback (resume-first landing)
  resumeFeedback: {
    sectionTitle: "Анализ резюме",
    scoreLabel: "Оценка резюме",
    strengthsTitle: "Сильные стороны",
    improvementsTitle: "Области для улучшения",
    overallAssessmentTitle: "Общая оценка",
  },

  // Post-Analysis CTA section (resume-first landing)
  postAnalysis: {
    ctaHeading: "Хотите пройти пробное интервью по вашему резюме?",
    ctaSubtext: "ИИ-интервьюер задаст целевые вопросы по вашему опыту и навыкам — как на реальной встрече.",
    signInBtn: "Войти и начать",
    freeTrialText: "3 бесплатных интервью после регистрации",
    pricingInfo: "$5 за 3 дополнительных интервью",
    feature1: "Голосовое интервью с обратной связью ИИ в реальном времени",
    feature2: "Определение границ ваших знаний",
    feature3: "Подробная оценка готовности и отчёт",
  },

  // Resume status (Landing for signed-in users)
  resumeStatus: {
    attached: "Ваше резюме",
    uploadedAt: "Обновлено",
    changeBtn: "Изменить",
    noResume: "Резюме пока не загружено",
    noResumeHint: "Добавьте резюме, чтобы интервью было точнее под ваш опыт",
    uploadBtn: "Загрузить",
    uploadTitle: "Загрузить резюме",
    replaceTitle: "Заменить резюме",
    cancel: "Отмена",
    syncing: "Сохраняем ваше резюме...",
    syncingHint: "Это займёт несколько секунд — мы извлекаем текст для интервью.",
  },

  success: {
    title: "Оплата прошла успешно!",
    desc: "Теперь у вас есть доступ к 3 полным глубоким интервью.",
    email: "Аккаунт",
    startBtn: "Начать интервью",
    errorTitle: "Что-то пошло не так",
    errorDesc: "Не удалось подтвердить оплату. Если вы уже оплатили, введите email на главной странице.",
    goHome: "На главную",
  },
  // B2B CRM
  crm: {
    nav: {
      homeAria: "HireFit CRM — на главную",
      billing: "Оплата",
      signIn: "Войти",
    },
    landing: {
      badge: "AI-платформа для найма",
      title: "Нанимайте умнее с голосовыми AI-интервью.",
      subtitle:
        "Создайте вакансию, поделитесь ссылкой — и HireFit проведёт настоящее голосовое интервью с каждым кандидатом. Вы получите отчёт с оценками, полную расшифровку и резюме. Без часа в Zoom.",
      openCrm: "Открыть CRM",
      seeHow: "Как это работает",
      trustFreeToStart: "Бесплатный старт",
      trustNoCard: "Без банковской карты",
      trustSetup: "Настройка за 2 минуты",
      feature1Title: "Создавайте вакансии за минуты",
      feature1Desc:
        "Вставьте описание вакансии, добавьте свои отборочные вопросы — и получите брендированную страницу интервью с уникальной ссылкой, готовую к отправке кандидатам.",
      feature2Title: "AI проводит интервью с кандидатами 24/7",
      feature2Desc:
        "Наш AI-интервьюер проводит структурированные технические и поведенческие интервью на основе ваших требований к вакансии — без согласования времени.",
      feature3Title: "Отслеживайте результаты и сравнивайте",
      feature3Desc:
        "Получайте подробные оценки компетенций, тревожные сигналы и планы развития для каждого кандидата. Сравнивайте кандидатов рядом друг с другом в дашборде.",
      feature4Title: "Назначайте созвоны мгновенно",
      feature4Desc:
        "Отправляйте приглашения Calendly прямо из профиля кандидата. Оставляйте заметки, отслеживайте прогресс и продвигайте лучших — всё в одном месте.",
      sectionTitle: "Всё, что нужно для умного найма",
      sectionSubtitle:
        "От создания вакансии до оценки кандидата — оптимизируйте весь процесс найма с помощью AI.",
      signInCta: "Войдите, чтобы начать",
    },
    dashboard: {
      title: "Вакансии",
      subtitle: "Управляйте вакансиями и отслеживайте кандидатов",
      newVacancy: "Новая вакансия",
      loading: "Загрузка вакансий…",
      retry: "Повторить",
      emptyTitle: "Пока нет вакансий",
      emptyDesc: "Создайте первую вакансию, чтобы начать проводить интервью с кандидатами с помощью AI.",
      emptyCta: "Создать первую вакансию",
      colVacancy: "Вакансия",
      colCreated: "Создана",
      colCandidates: "Кандидаты",
      colPublicUrl: "Публичная ссылка",
      colActions: "Действия",
      copyUrl: "Скопировать ссылку",
      copied: "Скопировано!",
      deleteVacancy: "Удалить вакансию",
      deleteConfirm: "Удалить эту вакансию? Кандидаты больше не смогут её открыть.",
    },
    vacancy: {
      loadingCandidates: "Загрузка кандидатов…",
      backToVacancies: "К списку вакансий",
      backToAdmin: "В админку",
      edit: "Редактировать",
      editVacancy: "Редактировать вакансию",
      updatedSuccess: "Вакансия успешно обновлена!",
      title: "Название *",
      jobDescription: "Описание вакансии *",
      duration: "Длительность",
      level: "Уровень",
      languages: "Языки",
      resultEmails: "Email для результатов",
      interviewFocus: "Фокус интервью",
      interviewAvoid: "Чего избегать в интервью",
      saving: "Сохранение…",
      saveChanges: "Сохранить изменения",
      cancel: "Отмена",
      statTotalCandidates: "Всего кандидатов",
      statAverageScore: "Средний балл",
      statReadiness: "Готовность",
      filterAll: "Все",
      filterNew: "Новые",
      filterInProgress: "В процессе",
      filterAdvanced: "Прошли дальше",
      filterRejected: "Отклонённые",
      noCandidatesWithStatus: "Нет кандидатов с этим статусом.",
      emptyTitle: "Пока нет кандидатов",
      emptyDesc: "Поделитесь ссылкой на вакансию с кандидатами, чтобы начать получать результаты интервью.",
      colCandidate: "Кандидат",
      colStatus: "Статус",
      colCountry: "Страна",
      colInterviewDate: "Дата интервью",
      colAvgScore: "Средний балл",
      colVerdict: "Вердикт",
      colContacts: "Контакты",
      colFiles: "Файлы",
      fileScreenRecording: "Запись экрана",
      fileWebcamRecording: "Запись с веб-камеры",
    },
    candidate: {
      loading: "Загрузка кандидата…",
      backToCandidates: "К списку кандидатов",
      back: "Назад",
      screenRecording: "Запись экрана",
      webcamRecording: "Запись с веб-камеры",
      statusLabel: "Статус:",
      avgScore: "средний балл",
      competencyBreakdown: "Разбор компетенций",
      modelAnswer: "Эталонный ответ",
      translating: "Переводим отчёт с английского…",
      redFlags: "Тревожные сигналы",
      studyPlan: "Рекомендуемый план развития",
      overallVerdict: "Итоговый вердикт",
      notes: "Заметки",
      scheduleCall: "Назначить созвон",
      calendlyLink: "Ссылка Calendly",
      personalMessage: "Личное сообщение",
      rejectTitle: "Отклонить кандидата",
      rejectPrompt: "При желании добавьте сообщение об отказе:",
      rejectPlaceholder: "Причина отказа (необязательно)...",
      confirmRejection: "Подтвердить отказ",
      cancel: "Отмена",
    },
    status: {
      new: "Новый",
      advanced: "Прошёл дальше",
      rejected: "Отклонён",
      inProgress: "В процессе",
    },
    newVacancy: {
      back: "Назад к панели",
      heading: "Создать вакансию",
      subheading: "Настройте вакансию, и ИИ автоматически проведёт собеседования с кандидатами.",
      companyLabel: "Название компании",
      companyPlaceholder: "напр. Acme Corp",
      companyHelper: "Будет использовано для генерации уникального URL вашей вакансии.",
      titleLabel: "Название вакансии",
      titlePlaceholder: "напр. Senior Frontend Developer",
      jdLabel: "Описание вакансии",
      cleanUp: "Очистить",
      cleaning: "Очистка…",
      jdPlaceholder: "Вставьте описание вакансии сюда. Кнопкой «Очистить» можно убрать артефакты форматирования.",
      jdHelper: "ИИ использует это, чтобы сгенерировать вопросы для собеседования. «Очистить» убирает артефакты форматирования после копирования.",
      customQuestionsLabel: "Дополнительные вопросы",
      customQuestionsHelper: "Добавьте вопросы, которые должен задать ИИ-интервьюер. Выберите, задавать каждый вопрос до или после технической части.",
      questionPlaceholder: "Введите вопрос…",
      removeQuestion: "Удалить вопрос",
      addQuestion: "Добавить вопрос",
      askLabel: "Когда:",
      askBefore: "До собеседования",
      askAfter: "После собеседования",
      customFieldPlaceholders: [
        "Где вы находитесь?",
        "Какую зарплату вы рассматриваете?",
        "Когда вы готовы приступить?",
        "Готовы ли вы к переезду?",
        "Есть ли у вас опыт удалённой работы?",
        "Какой у вас срок отработки?",
        "Есть ли у вас разрешение на работу в этой стране?",
        "Какой график работы вам предпочтителен?",
        "Планируете ли вы поездки в ближайшее время?",
        "Какими языками вы свободно владеете?",
      ],
      durationLabel: "Длительность собеседования",
      durationHelper: "Определяет глубину и количество вопросов, которые задаст ИИ-интервьюер.",
      durationScreening: "15 мин (скрининг)",
      duration30: "30 мин",
      duration45: "45 мин",
      duration60: "1 час",
      screeningBadge: "Скрининг",
      levelLabel: "Уровень позиции",
      levelHelper: "ИИ откалибрует сложность вопросов и оценку под ожидаемый уровень.",
      levelIntern: "Стажёр",
      levelJunior: "Junior",
      levelMiddle: "Middle",
      levelSenior: "Senior",
      levelLead: "Lead",
      levelPrincipal: "Principal",
      languagesLabel: "Языки собеседования",
      languagesHelper: "Кандидаты смогут выбрать один из этих языков при старте собеседования.",
      langEn: "Английский",
      langRu: "Русский",
      langCz: "Чешский",
      optional: "(необязательно)",
      focusLabel: "Сделать акцент на",
      focusPlaceholder: "напр. Спросить про опыт работы с ATS-системами, Boolean-поиском, закрытием технических ролей, взаимодействием с нанимающими менеджерами...",
      focusHelper: "Подскажите ИИ, какие темы затронуть. Оставьте пустым — и ИИ решит сам на основе описания вакансии.",
      avoidLabel: "Не спрашивать про",
      avoidPlaceholder: "напр. Не задавать вопросы по программированию или системному дизайну — это нетехническая роль...",
      avoidHelper: "Укажите ИИ, что пропустить. Полезно для нетехнических ролей, где технологии в описании упомянуты как контекст, а не как требование.",
      resultEmailsLabel: "E-mail для результатов",
      resultEmailsPlaceholder: "email1@example.com, email2@example.com",
      resultEmailsHelper: "Необязательно. Результаты собеседований будут отправлены на эти адреса дополнительно к e-mail вашего аккаунта.",
      submit: "Создать вакансию",
      submitting: "Создание вакансии…",
      successTitle: "Вакансия создана!",
      successSubtitle: "Поделитесь этой ссылкой с кандидатами, чтобы начать собеседования:",
      copy: "Копировать",
      copied: "Скопировано!",
      viewCandidates: "Смотреть кандидатов",
      errCompanyRequired: "Укажите название компании",
      errMaxQuestions: "Максимум 10 дополнительных вопросов",
      errQuestionTooLong: "Вопрос {n} превышает 200 символов",
      errEmptyQuestion: "Вопрос {n} пустой — введите текст или удалите его.",
      suggestionsLabel: "Примеры (нажмите, чтобы добавить):",
      errInvalidEmails: "Некорректные e-mail: {emails}",
      errCleanFailed: "Не удалось очистить описание вакансии",
      errCreateFailed: "Не удалось создать вакансию",
    },
  },
} as const;

export default ru;
